let bar: HTMLElement | null = null;

export function initConnectionStatus(): void {
  bar = document.createElement('div');
  bar.className = 'connection-bar connection-bar--hidden';
  document.body.prepend(bar);

  // React to system online/offline events
  window.addEventListener('offline', () => showOffline());
  window.addEventListener('online', () => hideStatus());
}

export function showOffline(): void {
  if (!bar) return;
  bar.textContent = 'Нет сети. Проверьте подключение';
  bar.className = 'connection-bar connection-bar--offline';
}

export function showReconnecting(): void {
  if (!bar) return;
  bar.textContent = 'Переподключение...';
  bar.className = 'connection-bar connection-bar--reconnecting';
}

export function hideStatus(): void {
  if (!bar) return;
  // /review 2026-05-04 v0.80.7 F1 — respect a real offline state. The system
  // 'offline' event handler at line 9 already claimed this bar, and a true
  // network outage cannot be hidden by a view teardown — the user needs to
  // see «Нет сети» until the network actually comes back. Without this
  // guard, destroyLobbyView/destroySpectatorView (added in v0.80.7) would
  // silently strip the offline indicator on view-swap, leaving an offline
  // user staring at /join with no signal that nothing will work.
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    showOffline();
    return;
  }
  bar.className = 'connection-bar connection-bar--hidden';
}
